import classNames from 'classnames';
import './NavContainer.scss';

export interface NavContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * NavContainer component, used as wrapper to apply page gutter padding
 * @param children - Any React.Node element
 */
export const NavContainer: React.FC<NavContainerProps> = ({ children, className, ...rest }) => {
  return (
    <div className={classNames('vds-nav-container', className)} {...rest}>
      {children}
    </div>
  );
};

export default NavContainer;
